import React from 'react';
import './Courses.css';

const Courses = () => {
  return (
    <div className="courses-page animate-fade-in">
      <h1 className="courses-title">Our Curriculum</h1>

      <section className="courses-section animate-slide-up">
        <h2>Classes 6 to 8</h2>
        <p>General foundation subjects as per UP Board standards.</p>
      </section>

      <section className="courses-section animate-slide-up">
        <h2>Classes 9 and 10</h2>
        <ul>
          <li>Humanities</li>
          <li>Science</li>
          <li>Home Science</li>
        </ul>
      </section>

      <section className="courses-section animate-slide-up">
        <h2>Classes 11 and 12</h2>
        <ul className="grid-list">
          <li>Biology</li>
          <li>Math</li>
          <li>Commerce</li>
          <li>Agriculture</li>
          <li>Humanities</li>
        </ul>
      </section>
    </div>
  );
};

export default Courses;
